module.exports = __webpack_public_path__ + "static/media/124.21066319.jpg";